<template>
    <div class="upload-image-container">
        <div class="image-display-container">
            <img
                class="image-display"
                @click="changeProfile()"
                :class="[{'pointer-cursor': isEditing}]"
                :src="img">

            <input
                ref="fileProfile"
                type="file"
                class="file-profile"
                accept="image/png, image/jpeg, image/jpg"
                @change="onSelectFile">

            <span
                v-if="isEditing"
                @click="changeProfile()"
                class="edit-icon">
                <v-icon
                    color="white"
                    size="18">
                    mdi-pencil-outline
                </v-icon>
            </span>
        </div>
        <div class="pointer-cursor remove-container" v-if="isEditing && canDelete" @click="removeImage">
            <div class="mr-2">
                <v-icon>
                    mdi-trash-can-outline
                </v-icon>
            </div>
            <span class="remove-text">
                {{ this.$vuetify.lang.t('$vuetify.uploadimage.remove') }}
            </span>
        </div>
        <p class="image-condition-for-dmp" v-if="showDescriptionForUploadToDmp">
            {{ this.$vuetify.lang.t('$vuetify.visitorForm.ImageSizeCanNot200Kb') }}
        </p>
    </div>
</template>

<script>
export default {
    name: 'UploadImage',

    props: {
        img: {
            type: String,
            default: ''
        },
        canDelete: {
            type: Boolean,
            default: true
        },
        isEditing: {
            type: Boolean,
            default: true
        },
        showDescriptionForUploadToDmp: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        changeProfile () {
            if (this.isEditing) {
                this.$refs.fileProfile.click()
            }
        },

        onSelectFile (files) {
            this.$emit('change-profile-img', files)
        },

        removeImage () {
            this.$emit('remove-img')
        }
    }
}
</script>

<style lang="scss" scoped>
.upload-image-container {
    width: 160px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .image-display-container {
        width: 96px;
        display: flex;
        position: relative;
    }

    .image-display {
        border-radius: 50%;
        width: 100px;
        height: 100px;
        margin-bottom: 16px;
    }

    .file-profile {
        display: none;
    }

    .edit-icon {
        cursor: pointer;
        bottom: 16px;
        right: 0;
        position: absolute;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #D76436;
        color: #fff;
    }

    .remove-container {
        display: flex;
        align-items: baseline;

        .remove-text {
            font-family: 'Roboto';
            color: #a8a8a8;
            font-size: 14px;
            font-weight: normal;
        }
    }

    .pointer-cursor {
        cursor: pointer;
    }

    .image-condition-for-dmp {
        text-align: center;
        font-size: 12px;
        color: #6c6c6c;
    }
}
</style>
